import actions from "./actions";

const initialState = {
  data: {},
  loading: false,
  isLogin: false,
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
